import { render, staticRenderFns } from "./reg-channels-edit.vue?vue&type=template&id=7569b0a5&scoped=true"
import script from "./reg-channels-edit.vue?vue&type=script&lang=js"
export * from "./reg-channels-edit.vue?vue&type=script&lang=js"
import style0 from "./reg-channels-edit.vue?vue&type=style&index=0&id=7569b0a5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569b0a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7569b0a5')) {
      api.createRecord('7569b0a5', component.options)
    } else {
      api.reload('7569b0a5', component.options)
    }
    module.hot.accept("./reg-channels-edit.vue?vue&type=template&id=7569b0a5&scoped=true", function () {
      api.rerender('7569b0a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelsmanage/components/reg-channels-edit.vue"
export default component.exports